// extracted by mini-css-extract-plugin
export default {"left":"Review_left__F5NWP","right":"Review_right__s0tNf","Review":"Review_Review__fuUQq"};